import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { MOBILE_BOTTOM_NAV, filterNavForUser } from '../config/hospitalNav';

export default memo(function MobileBottomNav({ onOpenMenu }) {
  const { currentUser, emergencyAlertCount } = useApp();
  const allowed = new Set(filterNavForUser(
    MOBILE_BOTTOM_NAV.filter(i => i.path !== '__menu__'),
    currentUser,
  ).map(i => i.path));

  return (
    <nav className="mobile-bottom-nav" aria-label="Main navigation">
      {MOBILE_BOTTOM_NAV.map(({ path, icon: Icon, label, emergency }) => {
        if (path === '__menu__') {
          return (
            <button
              key="menu"
              type="button"
              className="mobile-bottom-nav__item"
              onClick={onOpenMenu}
              aria-label="Open full menu"
            >
              <span className="mobile-bottom-nav__icon"><Icon /></span>
              <span className="mobile-bottom-nav__label">{label}</span>
            </button>
          );
        }
        if (!allowed.has(path)) return null;

        const badge = emergency && emergencyAlertCount > 0 ? emergencyAlertCount : 0;

        return (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) =>
              `mobile-bottom-nav__item${isActive ? ' is-active' : ''}${emergency ? ' is-emergency' : ''}`
            }
          >
            <span className="mobile-bottom-nav__icon">
              <Icon />
              {badge > 0 && (
                <span className="mobile-bottom-nav__badge" aria-label={`${badge} active alerts`}>
                  {badge > 9 ? '9+' : badge}
                </span>
              )}
            </span>
            <span className="mobile-bottom-nav__label">{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
});
